import UAParser from 'ua-parser-js'

export function getUAInfo(): UAParser.IResult {
  return new UAParser(navigator.userAgent).getResult()
}
